import { Icon } from '@acme/assets';

interface ChatToggleProps {
  onClick: () => void;
  hasNewMessages: boolean;
}

export const ChatToggle = ({ onClick, hasNewMessages }: ChatToggleProps) => {
  return (
    <button
      onClick={onClick}
      className="chat-toggle flex items-center justify-between gap-3 text-gray-700 hover:text-brand-primary-default transition-colors text-left"
    >
      <span className="flex-grow">Чат поддержки</span>
      <div className="relative">
        <Icon name="message-dots-outline" />
        {hasNewMessages && (
          <>
            <div className="absolute -top-1 -right-2 w-3 h-3 bg-brand-purple-900 rounded-full animate-ping"></div>
            <div className="absolute -top-1 -right-2 w-3 h-3 bg-brand-purple-900 rounded-full"></div>
          </>
        )}
      </div>
    </button>
  );
};
